import styled from 'styled-components';

/**
 * Component fills parent with position='relative' and centers children on it
 */

interface ICoverProps {
  clickThrough?: boolean;
  zIndex?: string;
}

export const Cover = styled.div.attrs((props: ICoverProps) => ({
  'data-test-class': 'cover',
  clickThrough: props.clickThrough,
}))<ICoverProps>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: ${(props) => (props.clickThrough ? 'blur(0px)' : 'blur(2px)')};
  pointer-events: ${(props) => (props.clickThrough ? 'none' : 'auto')};
  z-index: ${(props) => (props.zIndex ? props.zIndex : 'auto')};
`;
